
<template>
  <top-view>
    <v-card id="cardView">
      <v-row>
        <p class="profileHeader">{{ $t("profile_my_profile") }}</p>
        <v-divider class="divider"></v-divider>
      </v-row>
      <v-layout row>
        <v-flex xs12 sm2 md4></v-flex>
        <v-flex xs12 sm8 md4>
          <v-row>
            <p class="headerText">
              {{ $t("changePass_old_password") }}
              <i class="mdi mdi-information importantIcon"></i>
            </p>
          </v-row>
          <v-text-field
            class="textField"
            single-line
            required
            outline
            maxlength="30"
            type="password"
            v-model="oldPass"
          ></v-text-field>

          <v-row>
            <p class="headerText">
              {{ $t("changePass_new_password") }}
              <i class="mdi mdi-information importantIcon"></i>
            </p>
          </v-row>
          <v-text-field
            single-line
            required
            outline
            class="textField"
            maxlength="30"
            type="password"
            v-model="newPass"
          ></v-text-field>
          <v-row>
            <p class="headerText">
              {{ $t("changePass_confirm_password") }}
              <i class="mdi mdi-information importantIcon"></i>
            </p>
          </v-row>
          <v-text-field
            single-line
            required
            outline
            class="textField"
            maxlength="30"
            type="password"
            v-model="confirmNewPass"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm8 md4></v-flex>
      </v-layout>
      <div class="text-center btnPos">
        <v-btn
          class="mx-2 my-2"
          id="btnCancel"
          v-on:click="cancelClicked"
        >{{ $t("common_cancel") }}</v-btn>
        <v-btn
          class="btnMargin mx-2 my-2"
          id="btnChangePass"
          v-on:click="changePassword"
        >{{ $t("change_password") }}</v-btn>
      </div>
    </v-card>
  </top-view>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { ListEvents } from "@/utilities/CommonUtilities";
import TopView from "../../components/commonui/topView/TopViewFullScreen";

export default {
  components: { TopView },
  data() {
    return {
      newPass: null,
      confirmNewPass: null,
      oldPass: null,
      isChangeSuccessed: false,
      isDestroyed: false
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    ...mapMutations({
      signOut: "signOut"
    }),
    cancelClicked() {
      this.$router.push("/editprofile/" + this.userInfo.userID);
    },
    async changePassword() {
      if (!this.oldPass || !this.oldPass.trim()) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("changePass_old_password_empty_msg")
        );
        return;
      }
      if (!this.newPass || !this.newPass.trim()) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("changePass_new_password_empty_msg")
        );
        return;
      }
      if (this.newPass.length < 8) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("changePass_new_password_length_msg")
        );
        return;
      }

      if (this.newPass.length > 30) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("changePass_new_password_max_length_msg")
        );
        return;
      }

      if (this.newPass != this.confirmNewPass) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("changePass_confirm_password_incorrect_msg")
        );
        return;
      }

      this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      let dictParams = {
        oldPassword: this.oldPass,
        newPassword: this.newPass
      };
      try {
        await this.dataSource.postData(
          this.dataSource.changePasswordURL,
          dictParams
        );
        this.isChangeSuccessed = true;
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("common_updateSuccessfully")
        );
      } catch (ex) {
        this.notifyBus.$emit(
          ListEvents.showOKDialog,
          this.$i18n.t("common_unknown_error")
        );
        return;
      } finally {
        this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
      }
    }
  },
  created() {
    this.notifyBus.$on(ListEvents.tappedOKAction, () => {
      if (!this.isChangeSuccessed || this.isDestroyed) return;
      this.$router.push("/editprofile/" + this.userInfo.userID);
    });
  },
  beforeDestroy: function() {
    this.isDestroyed = true;
  },
  inject: ["dataSource", "notifyBus"]
};
</script>

<style scoped>
#cardView {
  width: 100%;
  height: 100%;
}
.profileHeader {
  margin-top: 37px;
  margin-left: 60px;
  margin-right: 20px;
  width: 142px;
  height: 33px;
  text-transform: uppercase;
  color: #333333;
  font: normal normal bold 24px/33px Open Sans;
  white-space: nowrap;
}
.divider {
  margin-top: 63px;
  margin-right: 10px;
}
.headerText {
  margin-top: 20px;
  margin-left: 10px;
  width: 0%;
  height: 22px;
  font: normal normal bold 16px/22px Open Sans;
  color: #333333;
  white-space: nowrap;
}
@media only screen and (max-width: 600px) {
  .headerText {
    margin-left: 40px;
  }
}
.importantIcon {
  color: #e561a9;
}
#btnCancel {
  background-color: #e561a9;
  width: 164px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

#btnEdit {
  background-color: #5e81ed;
  width: 164px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

#btnChangePass {
  background-color: #5e81ed;
  width: 164px;
  height: 35px;
  color: #ffffff;
  font-size: 12px;
  font: normal normal bold 13px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

.textField {
  margin-bottom: 20px;
  margin-top: -20px;
  height: 28px;
  margin-left: 30px;
  margin-right: 30px;
}
@media only screen and (min-width: 600px) {
  .textField {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
}
.btnPos {
  margin-top: 40px;
}
</style>

